import { motion as motionTokens } from '@theme/tokens';
import type { Variants } from 'framer-motion';

/**
 * Shared framer-motion variants — the app-wide choreography vocabulary
 * (docs/redesign/04-motion-map.png). Containers stagger, items settle in
 * with a spring, reward moments pop. Only `transform` and `opacity`.
 */

/** Parent for staggered lists/grids; pair children with `fadeUpItem`. */
export const staggerContainer: Variants = {
  hidden: {},
  show: { transition: { staggerChildren: motionTokens.stagger } },
};

/** Card/list-item arrival: rises 16px and settles with a spring. */
export const fadeUpItem: Variants = {
  hidden: { opacity: 0, y: 16 },
  show: { opacity: 1, y: 0, transition: motionTokens.spring },
};

/** Quiet fade for route/panel content. */
export const fadeIn: Variants = {
  hidden: { opacity: 0, y: 8 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: motionTokens.duration.standard, ease: motionTokens.ease.standard },
  },
};

/** Reward pop for markers and success badges (motion-map R3). */
export const popIn: Variants = {
  hidden: { opacity: 0, scale: 0.6 },
  show: { opacity: 1, scale: 1, transition: motionTokens.springReward },
};

/** Slide-over panel from the left (door detail on the plan canvas). */
export const slideOverLeft: Variants = {
  hidden: { opacity: 0, x: -24 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: motionTokens.duration.standard, ease: motionTokens.ease.out },
  },
  exit: {
    opacity: 0,
    x: -24,
    transition: { duration: motionTokens.duration.micro, ease: motionTokens.ease.standard },
  },
};

/** Slide-over panel from the right (door list overlay on the plan canvas). */
export const slideOverRight: Variants = {
  hidden: { opacity: 0, x: 24 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: motionTokens.duration.standard, ease: motionTokens.ease.out },
  },
  exit: {
    opacity: 0,
    x: 24,
    transition: { duration: motionTokens.duration.micro, ease: motionTokens.ease.standard },
  },
};
